import React, { useEffect, useRef, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import {
  displayError,
  displaySuccess,
  getNriProviders,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import config from "../config/config";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";
import "../Gynac/style.css";

const AVATAR_PALETTE = [
  '#c22627', '#5a4cdb', '#d6336c', '#2b6cb0', '#e8590c',
  '#0ca678', '#7048e8', '#1098ad', '#f08c00', '#37b24d',
];

const colorForName = (name = '') => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

const initialsOf = (name = '') => {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (parts[0]) return parts[0].substring(0, 2).toUpperCase();
  return '?';
};

const statusClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'approved' || s === 'approve') return 'status-pill status-approved';
  if (s === 'rejected' || s === 'reject') return 'status-pill status-rejected';
  return 'status-pill status-pending';
};

const ProviderNriList = (props) => {
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalProviders, setTotalProviders] = useState(0);
  const [statusModal, setStatusModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const getList = async (perPage = count, pageNum = 1, searchQuery = search, status = statusFilter) => {
    props.toggleLoader(true);
    const res = await getNriProviders(perPage, pageNum, searchQuery, status);
    setTotal(res?.metadata?.totalPage);
    setTotalProviders(res?.metadata?.totalCount);
    setPage(res?.metadata?.page);
    setUsers(res?.data || []);
    props.toggleLoader(false);
  };

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      getList(count, 1, search, statusFilter);
      return;
    }
    const handler = setTimeout(() => {
      getList(count, 1, search, statusFilter);
    }, 400);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter]);

  const deleteProvider = async () => {
    if (!deleteTarget?._id) return;
    const token = localStorage.getItem("token");
    setDeleting(true);
    props.toggleLoader(true);
    try {
      await axios.get(`${config.siteUrl}/delete-provider/${deleteTarget._id}`, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      displaySuccess("Deleted Successfully");
      setDeleteTarget(null);
      await getList(count, page);
    } catch (error) {
      displayError(error);
    } finally {
      setDeleting(false);
      props.toggleLoader(false);
    }
  };

  const openStatusModal = (provider) => {
    setSelectedProvider(provider);
    setStatusModal(true);
  };

  const changeStatus = async (status) => {
    try {
      const token = localStorage.getItem("token");
      props.toggleLoader(true);
      await axios.post(`${config.siteUrl}/provider/update-status`,
        { provider_id: selectedProvider._id, status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      displaySuccess(`Provider ${status} successfully`);
      setStatusModal(false);
      setSelectedProvider(null);
      await getList(count, page);
    } catch (err) {
      displayError(err);
    } finally {
      props.toggleLoader(false);
    }
  };

  const handlePageClick = async (e) => {
    const selectedPage = e.selected + 1;
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    getList(count, selectedPage);
  };

  const handlePerPageChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setCount(next);
    getList(next, 1);
  };

  const filteredUsers = users || [];

  return (
    <div className="g-sidenav-show bg-gray-100">
      <div id="wrapper">
        <Leftbar />
        <main className="main-content border-radius-lg">
          <Topbar />

          <div className="header bg-primary pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                        <li className="breadcrumb-item"><a href="#">Service Providers</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt--6"></div>
          <div className="container-fluid">
            <div className="card gynac-card">
              <div className="gynac-card-header">
                <h3 className="gynac-title">
                  Service Providers Listing
                  <span className="gynac-count-chip">
                    {totalProviders ? totalProviders : 0}{search || statusFilter !== 'all' ? ` of ${users.length}` : ''}
                  </span>
                </h3>

                <div className="gynac-toolbar">
                  <div className="gynac-search">
                    <i className="fas fa-search search-icon" />
                    <input
                      type="text"
                      placeholder="Search name, email or phone"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="gynac-filter">
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                      <option value="all">All status</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                  <Link to="/add-providers">
                    <button className="btn gynac-add-btn">
                      <i className="fas fa-plus" style={{ marginRight: 6 }} />
                      Add Provider
                    </button>
                  </Link>
                </div>
              </div>

              <div className="table-responsive">
                <table className="gynac-table">
                  <colgroup>
                    <col style={{ width: '26%' }} />
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '16%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '26%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Provider</th>
                      <th>Contact</th>
                      <th>Service / Type</th>
                      <th style={{ textAlign: 'center' }}>Status</th>
                      <th style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => {
                      const name = user?.name || '—';
                      const initials = initialsOf(name);
                      const avatarColor = colorForName(name);

                      return (
                        <tr key={user?._id}>
                          <td data-label="Provider">
                            <div className="doctor-cell">
                              <span className="doctor-avatar-fallback" style={{ background: avatarColor }}>
                                {initials}
                              </span>
                              <div className="doctor-info">
                                <span className="doctor-name" title={name}>{name}</span>
                                {user?.experience && (
                                  <span className="doctor-email">
                                    <i className="fas fa-briefcase" style={{ marginRight: 4, fontSize: '0.7rem' }} />
                                    {user.experience}
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>

                          <td data-label="Contact">
                            {user?.email && (
                              <div style={{ marginBottom: 4 }}>
                                <a href={`mailto:${user.email}`} className="doctor-email" title={user.email}>
                                  {user.email}
                                </a>
                              </div>
                            )}
                            {user?.phone_number ? (
                              <div className="contact-line">
                                <i className="fas fa-phone fa-flip-horizontal" />
                                +{user.phone_number}
                              </div>
                            ) : null}
                            {!user?.email && !user?.phone_number && <span className="text-muted">—</span>}
                          </td>

                          <td data-label="Service / Type">
                            <div className="cred-line">
                              {user?.service?.name && (
                                <span className="cred-experience">{user.service.name}</span>
                              )}
                              {user?.type && (
                                <span className="cred-education" style={{ textTransform: 'capitalize' }}>{user.type}</span>
                              )}
                              {!user?.service?.name && !user?.type && <span className="text-muted">—</span>}
                            </div>
                          </td>

                          <td data-label="Status" style={{ textAlign: 'center' }}>
                            <span className={statusClass(user?.status)}>{user?.status || 'pending'}</span>
                          </td>

                          <td data-label="Action" style={{ textAlign: 'center' }}>
                            <div className="action-stack action-stack-compact">
                              <Link to={`/add-providers?id=${user._id}`}>
                                <button className="btn-pill btn-approve">
                                  <i className="fas fa-pen" style={{ marginRight: 5, fontSize: '0.7rem' }} />
                                  Edit
                                </button>
                              </Link>
                              {user?.status === 'pending' && (
                                <button
                                  className="btn-pill btn-approve"
                                  style={{ background: '#fff4e1', borderColor: '#d97706', color: '#d97706' }}
                                  onClick={() => openStatusModal(user)}
                                >
                                  Change status
                                </button>
                              )}
                              <button
                                className="btn-pill btn-reject"
                                onClick={() => setDeleteTarget(user)}
                              >
                                <i className="fas fa-trash" style={{ marginRight: 5, fontSize: '0.7rem' }} />
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}

                    {!filteredUsers.length && (
                      <tr>
                        <td colSpan={5}>
                          <div className="gynac-empty">
                            <i className="fas fa-user-friends" />
                            <div className="gynac-empty-text">No service providers found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {users.length > 0 && (
                <div className="gynac-footer">
                  <div className="gynac-per-page">
                    <span>Rows per page</span>
                    <select value={count} onChange={handlePerPageChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <div className="paginate-css" style={{ margin: 0 }}>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={total}
                      forcePage={page > 0 ? page - 1 : 0}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Delete confirm modal */}
          <Modal
            show={!!deleteTarget}
            onHide={() => !deleting && setDeleteTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#fdebec', color: '#c22627', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Delete provider?</h5>
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !deleting && setDeleteTarget(null)} disabled={deleting}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to delete{' '}
              <strong style={{ color: '#1f2540' }}>{deleteTarget?.name || 'this provider'}</strong>?
              This action cannot be undone.
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setDeleteTarget(null)}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: deleting ? 0.7 : 1, cursor: deleting ? 'not-allowed' : 'pointer' }}
                onClick={deleteProvider}
                disabled={deleting}
              >
                <i className="fas fa-trash" style={{ marginRight: 6, fontSize: '0.78rem' }} />
                {deleting ? 'Deleting…' : 'Delete'}
              </button>
            </Modal.Footer>
          </Modal>

          {/* Status change modal */}
          <Modal show={statusModal} onHide={() => { setStatusModal(false); setSelectedProvider(null); }} centered>
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <h5 className="mb-0" style={{ fontWeight: 700 }}>Change Provider Status</h5>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => { setStatusModal(false); setSelectedProvider(null); }}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px' }}>
              <p className="mb-0">
                {selectedProvider?.name
                  ? <>Update status for <strong>{selectedProvider.name}</strong>. Do you want to approve or reject it?</>
                  : 'Update status for this provider. Do you want to approve or reject it?'}
              </p>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => { setStatusModal(false); setSelectedProvider(null); }}
              >
                Cancel
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => changeStatus('rejected')}
              >
                Reject
              </button>
              <button
                className="btn"
                style={{ background: '#0ca678', color: '#fff', border: '1px solid #0ca678', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => changeStatus('approved')}
              >
                Approve
              </button>
            </Modal.Footer>
          </Modal>
        </main>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleLoader };
const mapStateToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ProviderNriList);
